import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advertisementbanner2',
  templateUrl: './advertisementbanner2.component.html',
  styleUrls: ['./advertisementbanner2.component.css']
})
export class Advertisementbanner2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
